const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/IplBlockedView.css");

const COPY_ICON = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
	>
		<rect
			x="5"
			y="5"
			width="8"
			height="9"
			rx="1.5"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path
			d="M3 11V3a1 1 0 0 1 1-1h7"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);

const CHECK_ICON = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 16 16"
		fill="none"
		aria-hidden="true"
	>
		<path
			d="M3 8l3.5 3.5L13 4"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

module.exports = createReactClass({
	displayName: "IplBlockedCopyLink",

	propTypes: {
		url: PT.string.isRequired,
	},

	getInitialState: function() {
		return {copied: false};
	},

	componentWillUnmount: function() {
		if (this.resetTimeout) {
			clearTimeout(this.resetTimeout);
		}
	},

	onCopy: function() {
		if (!global.navigator || !global.navigator.clipboard) {
			return;
		}
		global.navigator.clipboard.writeText(this.props.url).then(() => {
			this.setState({copied: true});
			this.resetTimeout = setTimeout(() => {
				this.setState({copied: false});
			}, 1800);
		});
	},

	render: function() {
		return (
			<button
				type="button"
				className={
					styles.copyBtn + (this.state.copied ? " " + styles.copyBtnCopied : "")
				}
				title="Copy link"
				onClick={this.onCopy}
			>
				{this.state.copied ? CHECK_ICON : COPY_ICON}
			</button>
		);
	},
});
